/**
 * Arkius Certification Kickstarter API
 * Arkius PBC API v5.2026.1012.0845
 *
 * The version of the OpenAPI document: v1
 * Contact: info@arkius.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Variables } from './variables';
import { Hidden } from './hidden';
import { Calculated } from './calculated';


export interface FormResponse { 
    form_id?: string | null;
    token?: string | null;
    submitted_at?: string | null;
    landed_at?: string | null;
    calculated?: Calculated;
    variables?: Array<Variables> | null;
    hidden?: Hidden;
}

